module.exports = __webpack_public_path__ + "static/media/Donations_1.2a8083e4.jpg";